import { render, staticRenderFns } from "./BankCardForm.vue?vue&type=template&id=79e85bb2&"
import script from "./BankCardForm.vue?vue&type=script&lang=js&"
export * from "./BankCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports